import * as React from "react";

const SvgComponent = (props) => (
  <svg width="25" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_797_26282)">
      <path d="M1.32031 10.9048C1.32031 10.9048 4.65365 4.2381 10.487 4.2381C16.3203 4.2381 19.6536 10.9048 19.6536 10.9048C19.6536 10.9048 16.3203 17.5714 10.487 17.5714C4.65365 17.5714 1.32031 10.9048 1.32031 10.9048Z" stroke="#3A3A49" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.4844 13.4048C11.8651 13.4048 12.9844 12.2855 12.9844 10.9048C12.9844 9.52407 11.8651 8.40479 10.4844 8.40479C9.10366 8.40479 7.98438 9.52407 7.98438 10.9048C7.98438 12.2855 9.10366 13.4048 10.4844 13.4048Z" stroke="#3A3A49" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_797_26282">
        <rect width="20" height="20" fill="white" transform="translate(0.484375 0.904785)" />
      </clipPath>
    </defs>
  </svg>

);

export default SvgComponent;